var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.716,
    height: 13.716,
    viewBox: "0 0 13.716 13.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-free-breakfast",
    "data-name": "Icon material-free-breakfast",
    d: "M18.192,4.5H6v7.62a3.047,3.047,0,0,0,3.048,3.048H13.62a3.047,3.047,0,0,0,3.048-3.048V9.834h1.524A1.524,1.524,0,0,0,19.716,8.31V6.024A1.519,1.519,0,0,0,18.192,4.5Zm0,3.81H16.668V6.024h1.524ZM6,16.692H18.192v1.524H6Z",
    transform: "translate(-6 -4.5)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrunch);
export default __webpack_public_path__ + "static/media/brunch.4da5ff53897d0071625cc7915c110f5a.svg";
export { ForwardRef as ReactComponent };